<template>
  <div class="beacon-admin">
    <div class="beacon-admin-nav py-2 v-center space-between" >
    <div class="v-center space-between module-header w-100">
      <h1 class="module-name">Tenant Dashboard</h1>
      <div class="s">
      </div>
      </div>

      <div class="beacon-admin-kpi p-2 flex w-100">
        <div class="beacon-admin-kpi-blue mx-4 p-4">
          <div class="beacon-admin-kpi-header">Total Tenant</div>
          <div class="beacon-admin-kpi-value mt-3">{{ tenantList.length }}</div>
        </div>
        <div class="beacon-admin-kpi-brand p-4">
          <img src="~@/assets/images/bg-2.png" alt="" />
          <div class="beacon-admin-kpi-header">Activity</div>
          <div class="beacon-admin-kpi-value mt-3">
            Here Projects and Tenant Activity will come in graph format
          </div>
        </div>
      </div>

      <div class="tab p-2 v-center w-100 px-2">
        <div
          @click="setTab('companyList')"
          :class="{ active: openTabName === 'companyList' }"
        >
          Companies
        </div>
        <div
          @click="setTab('termsAndConditions')"
          class="mx-5"
          :class="{ active: openTabName === 'termsAndConditions' }"
        >
          Terms and Conditions
        </div>
        <div
          @click="setTab('tenantDataCopy')"
          class="mx-5"
          :class="{ active: openTabName === 'tenantDataCopy' }"
        >
          Tenant Data Copy
        </div>

      </div>

      <div v-if="openTabName === 'companyList'" class="beacon-admin-list w-100 px-2">
        <div class="beacon-admin-bar v-center space-between my-3">
          <h3 class="weight-500 xl">Company List</h3>
          <div class="v-center">
            <div class="input-group search">
              <input
                v-model="searchKeyword"
                type="text"
                @input="performSearch(searchKeyword)"
                placeholder="Search by Company Name, GSTIN"
              />
            </div>
            <router-link to="/invite-tenant">
              <button class="btn ml-3">Invite Tenant</button>
            </router-link>
          </div>
        </div>
        <copy-company-table
          :companyList="getSearchResult"
          :perPage="perPage"
          :pageNumber="pageNumber"
          :beaconAdmin="true"
          :showHeader="true"
        />
        <pagination
          :length="getSearchResult.length"
          :perPage="perPage"
          :pageNumber="pageNumber"
          @selectPage="selectPage"
          class="mt-3 mx-2"
        />
      </div>

      <div v-if="openTabName === 'termsAndConditions'" class="beacon-admin-list w-100 px-2">
        <terms-and-conditions
        ref="termsComponent"
        :termsData="termsData"
        :historyData="historyData"
        :isUploading="isUploading"
        @publish="handlePublish"
        @view-history="viewHistoryTerms"
        />
      </div>

      <div v-if="openTabName === 'tenantDataCopy'" class="beacon-admin-list w-100 px-2">
        <tenant-data-copy/>
        </div>
    </div>
  </div>
</template>

<script>
import { arraySearch } from '@/utils/array'
import copyCompanyTable from '@/components/common/copyCompanyTable.vue'
import Pagination from '../../components/common/pagination2.vue'
import TermsAndConditions from '../../components/common/termsAndConditions.vue'
import TenantDataCopy from '@/components/common/tenantDataCopy.vue'
import { mapGetters } from 'vuex'
import { generateS3DownloadingUrl, generateS3SubmittingUrl, createTermsAndConditions, getTermsHistory } from '@/api'
import { success, alert } from '@/plugins/notification'
import { genericFormatDate } from '@/utils/date'

export default {
  name: 'BeaconAdmin',
  components: { Pagination, copyCompanyTable, TermsAndConditions, TenantDataCopy },
  data () {
    return {
      openTabName: 'companyList',
      searchKeyword: '',
      pageNumber: 1,
      perPage: 10,
      termsData: {
        version: '',
        comments: '',
        fileUrl: null
      },
      historyData: [],
      isUploading: false
    }
  },
  computed: {
    ...mapGetters(['tenantList']),
    getSearchResult () {
      return arraySearch(this.tenantList, this.searchKeyword, {
        fieldsToSearch: ['company_name', 'GSTIN']
      })
    }
  },
  watch: {
    tenantList () {
      this.loadCompanyLogo()
    }
  },
  mounted () {
    this.loadCompanyLogo()
  },
  methods: {
    setTab (tab) {
      this.pageNumber = 1
      this.openTabName = tab
      this.searchKeyword = ''
      if (tab === 'termsAndConditions') {
        this.fetchTermsAndConditions()
      }
    },
    performSearch (keyword) {
      this.searchKeyword = keyword
      this.pageNumber = 1
    },

    selectPage (pageNumber) {
      this.pageNumber = pageNumber
    },

    loadCompanyLogo () {
      const S3Objects = this.tenantList
        .filter(item => item.company_logo_blob_key)
        .map(item => ({
          fileName: item.company_name,
          S3Key: item.company_logo_blob_key
        }))

      if (!S3Objects.length) return

      generateS3DownloadingUrl({ S3Objects })
        .then(res => {
          const logoMap = {}
          res.url.forEach(thumbnail => {
            logoMap[thumbnail.S3Key] = thumbnail.url
          })
          this.tenantList.forEach(company => {
            const url = logoMap[company.company_logo_blob_key]
            if (url) company.company_logo_blob_key = url
          })
        })
        .catch(err => console.error('Failed to load company logos:', err))
    },
    fetchTermsAndConditions () {
      getTermsHistory()
        .then(res => {
          const termsData = res.core_terms_condition || []
          this.historyData = termsData.map(item => ({
            id: item.id,
            version: item.version_no,
            date: genericFormatDate(item.created_on),
            description: item.comment || 'No description',
            blobKey: item.blob_key
          }))
        })
        .catch(err => {
          console.error('Failed to fetch terms history:', err)
          alert('Failed to fetch terms history')
        })
    },
    async viewHistoryTerms (item) {
      try {
        const { url } = await generateS3DownloadingUrl({
          S3Objects: [{
            fileName: `terms-${item.version}`,
            S3Key: item.blobKey
          }]
        })

        if (url?.length) {
          this.$refs.termsComponent.loadPdfFromSignedUrl(url[0].url)
        }
      } catch (err) {
        console.error(err)
        alert('Failed to load terms')
      }
    },
    async handlePublish (data) {
      if (!data.file) {
        alert('Please upload a file')
        return
      }
      try {
        this.isUploading = true
        const { url } = await generateS3SubmittingUrl({
          tenantId: 'beacon-admin',
          feature: 'terms',
          featureId: 'termsAndConditions',
          fileName: data.file.name
        })
        await fetch(url, {
          method: 'PUT',
          body: data.file,
          headers: { 'Content-Type': data.file.type }
        })
        const blobKey = url.split('?')[0].split('.com/').pop()
        await createTermsAndConditions(blobKey, data.comments)
        success('Terms and Conditions published successfully')
        this.fetchTermsAndConditions()
        this.$refs.termsComponent.clearForm()
      } catch (err) {
        console.error('Publish failed:', err)
        alert('Failed to publish')
      } finally {
        this.isUploading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.beacon-admin {
  height: 100%;
  &-nav {
    display: flex;
    flex-direction: column;
    align-items: baseline;
}
  &-kpi {
    align-items: stretch;
    color: var(--white);
    font-weight: 600;
    border-bottom: var(--border);
    &-blue {
      height: 180px;
      width: 225px;
      background-image: url("~@/assets/images/bg-1.png");
      border-radius: 6px;
    }
    &-brand {
      position: relative;
      flex-grow: 1;
      border-radius: 6px;
      background: linear-gradient(
        317.26deg,
        #dfa600 -26.68%,
        #ffc467 42.21%,
        #e8892a 90.37%
      );
      & img {
        position: absolute;
        bottom: 10px;
        right: 10px;
        height: 160px;
      }
      & .beacon-admin-kpi-value {
        font-size: var(--text-2xl);
      }
    }
    &-header {
      font-size: var(--text-3xl);
    }
    &-value {
      font-size: 64px;
    }
    &-list{
      width:100%;
    }
  }
  .tab {
    border-bottom: var(--border);
    & > div {
      cursor: pointer;
    }
    .active {
      font-weight: 500;
      border-bottom: 2px solid var(--brand-color);
    }
  }
}
</style>
